/* eslint-disable react/prop-types */
import React, { Fragment } from 'react'
import { Pagination } from 'react-bootstrap'
import styled from 'styled-components'

const LEFT_PAGE = 'LEFT'
const RIGHT_PAGE = 'RIGHT'

const range = (from, to, step = 1) => {
  let i = from
  const range = []

  while (i <= to) {
    range.push(i)
    i += step
  }

  return range
}

const Paginate = ({ totalPages = 0, activePage, setActivePage, themeColor }) => {
  const pageNeighbours = 1

  const handlePaginate = page => {
    if (page === RIGHT_PAGE) {
      setActivePage(activePage + pageNeighbours * 2 + 1)
    } else if (page === LEFT_PAGE) {
      setActivePage(activePage - pageNeighbours * 2 - 1)
    } else {
      setActivePage(page)
    }
  }

  const fetchPageNumbers = () => {
    const totalNumbers = pageNeighbours * 2 + 3
    const totalBlocks = totalNumbers + 2

    if (totalPages > totalBlocks) {
      let pages = []

      const leftBound = activePage - pageNeighbours
      const rightBound = activePage + pageNeighbours
      const beforeLastPage = totalPages - 1

      const startPage = leftBound > 2 ? leftBound : 2
      const endPage = rightBound < beforeLastPage ? rightBound : beforeLastPage

      pages = range(startPage, endPage)

      const pagesCount = pages.length
      const singleSpillOffset = totalNumbers - pagesCount - 1

      const leftSpill = startPage > 2
      const rightSpill = endPage < beforeLastPage

      const leftSpillPage = LEFT_PAGE
      const rightSpillPage = RIGHT_PAGE

      if (leftSpill && !rightSpill) {
        const extraPages = range(startPage - singleSpillOffset, startPage - 1)
        pages = [leftSpillPage, ...extraPages, ...pages]
      } else if (!leftSpill && rightSpill) {
        const extraPages = range(endPage + 1, endPage + singleSpillOffset)
        pages = [...pages, ...extraPages, rightSpillPage]
      } else if (leftSpill && rightSpill) {
        pages = [leftSpillPage, ...pages, rightSpillPage]
      }

      return [1, ...pages, totalPages]
    }

    return range(1, totalPages)
  }
  const pageItems = []
  const pages = fetchPageNumbers()

  for (let i = 0; i <= pages.length - 1; i++) {
    pageItems.push(
      <Pagination.Item
        as="button"
        key={pages[i]}
        active={pages[i] === activePage}
        onClick={e => {
          e.stopPropagation()
          handlePaginate(pages[i])
        }}
      >
        {pages[i] === LEFT_PAGE && <span>&laquo;</span>}
        {pages[i] === RIGHT_PAGE && <span>&raquo;</span>}
        {pages[i] !== RIGHT_PAGE && pages[i] !== LEFT_PAGE && <span>{pages[i]}</span>}
      </Pagination.Item>
    )
  }

  return (
    <>
      {typeof totalPages === 'number' && totalPages > 1 ? (
        <PaginationWrapper themeColor={themeColor}>{pageItems}</PaginationWrapper>
      ) : null}
    </>
  )
}

export default Paginate

const PaginationWrapper = styled(Pagination)`
  display: flex;
  justify-content: center;
  margin: 15px 0px;
  padding: 0px;
  .page-item.active {
    .page-link {
      background-color: ${props => (props.themeColor ? `${props.themeColor}` : null)};
      border-color: ${props => (props.themeColor ? `${props.themeColor}` : null)};
    }
  }
`
